import { escapeSql } from '@rdrive/helper-sql';
import { makeChartConfig } from '@rdrive/helper-chart-config';

// Item distribution by controlling team, for the controllers page donut.
// Returns raw rows — the bucketing of small slices into "Others", the slice
// colours and the unknown-team label are presentation and stay in the component.
export function useControllerDonutChart({ chartName, filterContext, conn }) {
  // `rows` is the plain-row runner (the donut does not use the stacked bar's
  // nested shape); `filterContext` may be a ref/computed or a plain object.
  const { rows: run, applyFilter, removeFilter } = makeChartConfig({ chartName, filterContext, conn });

  // Rows: { teamId, name (may be null), value }
  const getTeamDistribution = async (filtered = true) => {
    const table = filtered ? 'filteredItems' : 'items';
    const rows = await run(`
    SELECT
      i.controlledByTeamId AS teamId,
      t.name AS name,
      COUNT(*) AS value
    FROM ${table} i
    LEFT JOIN teams t ON i.controlledByTeamId = t.id
    GROUP BY i.controlledByTeamId, t.name
    ORDER BY value DESC
  `);

    return rows.map((row) => ({ ...row, value: Number(row.value) }));
  };

  // teamId === null clears this chart's filter registration
  const setTeamFilter = async (teamId) => {
    if (!teamId) {
      await removeFilter();
      return;
    }
    await applyFilter(`
    SELECT DISTINCT i.SubItemId
    FROM items i
    WHERE i.controlledByTeamId = '${escapeSql(teamId)}'
  `);
  };

  return { getTeamDistribution, setTeamFilter };
}
